import React from "react";
import style from "./OutcomeBlock.module.scss";
import { SelectBox } from "../../../../../primary";
import { BLEEDING_AMOUNT, PAIN_SCALE, YES_NO } from "../debridementConfig";

export const OutcomeBlock = ({ form, showPressure, disabled, onField }) => (
  <section className={`${style.form_section} ${disabled ? style.block_off : ""}`}>
    <div className={style.form_section_header}>
      <span className={style.form_section_number}>3</span>
      <span className={style.form_section_title}>Outcome</span>
    </div>

    <div className={style.form_section_body}>
      <div className={style.row2} style={{ gridTemplateColumns: "1fr"}}>
        <div className={style.field}>
          <label htmlFor="painAfter">Pain scale right after procedure</label>
          <SelectBox
            id="painAfter"
            name="painAfter"
            optionValue={PAIN_SCALE}
            defaultValue={form.painAfter === null ? "" : String(form.painAfter)}
            placeholder="Select..."
            disabled={disabled}
            classes={{ inputClassName: style.custom_basic_select }}
            onChange={(e) => onField("painAfter", e.target.value)}
          />
        </div>

        <div className={style.field}>
          <label htmlFor="postDebridementBleedingAmount">Bleeding</label>
          <SelectBox
            id="postDebridementBleedingAmount"
            name="postDebridementBleedingAmount"
            optionValue={BLEEDING_AMOUNT}
            defaultValue={form.postDebridementBleedingAmount || ""}
            placeholder="Select…"
            disabled={disabled}
            classes={{ inputClassName: style.custom_basic_select }}
            onChange={(e) => onField("postDebridementBleedingAmount", e.target.value)}
          />
        </div>
      </div>

      {showPressure && (
        <div className={style.field} data-testid="pressure-field">
          <label htmlFor="stoppedBleedingContactPressure">
            Pressure required to stop bleeding?
          </label>
          <SelectBox
            id="stoppedBleedingContactPressure"
            name="stoppedBleedingContactPressure"
            optionValue={YES_NO}
            defaultValue={form.stoppedBleedingContactPressure || ""}
            placeholder="Select…"
            disabled={disabled}
            classes={{ inputClassName: style.custom_basic_select }}
            onChange={(e) => onField("stoppedBleedingContactPressure", e.target.value)}
          />
        </div>
      )}
    </div>
  </section>
);
